import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { NuevoClienteDocumentacionModal } from "app/features/componentes/nuevoclientedocumentacion/modal";
import { ContactoClienteSelectorView } from "./contactoview";
import { AgregarClienteButton } from "./agregarcliente";
interface Props {
    value?: number;
    onChange: (x: number | undefined) => void;
    iconClass?: string;
    label?: string;
    error?: kea.FieldError;
    /**Filtro para los clientes */
    filtroCliente?: models.FiltroCliente;
    idSucursalUsuario?: number;
    /**Indica que se aplicará el permiso de documentar de cualquier origen */
    filtrarDireccionesPermiso?: boolean;
}

export class ContactoClienteSelector extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    handleOnNuevoCliente = async () => {
        const result = await this.modalManager.showModal(NuevoClienteDocumentacionModal, { contactoObligatorio: true }, {
            Direccion: {},
            AceptaFletePorCobrar: true,
            ImprimirPrecioGuia: true,
            SeguroViaje: true,
            NumeroPoliza: "",
            Identificacion: {}
        } as models.NuevoClienteDocumentacion);
        if (result.result) {
            const nuevo = await resources.Cliente.AddDocumentacion(result.value);
            this.props.onChange(nuevo.IdContactoCliente!);
        }
    }

    render() {        
        return (
            <kea.Panel title={this.props.label} iconClass={this.props.iconClass} buttons={<kea.AgregarButton onClick={this.handleOnNuevoCliente} />} error={this.props.error} >
                <ContactoClienteSelectorView {...this.props} />
                {this.modalManager.component}
            </kea.Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/selectores/items/direccioncliente/contacto.tsx